import { CreateRunTopicModel } from "models/CreateRunTopicModel";
import { getResource, isResourceKey } from "providers";
import React from "react";

interface EdecideTopicRowProps {
  topic: CreateRunTopicModel;
  index: number;
}

export const EdecideTopicRow: React.FC<EdecideTopicRowProps> = ({ topic, index }) => {
  const documents = topic.workingDocuments || [];

  const typeKey = `EdecideType_${topic.type}` as const;
  const tooltipKey = `EdecideType_${topic.type}_Tooltip` as const;
  const typeName = isResourceKey(typeKey) ? getResource(typeKey) : topic.type;
  const typeTooltip = isResourceKey(tooltipKey) ? getResource(tooltipKey) : "";
  const fragmentKey = `topic-${index}`;

  return (
    <React.Fragment key={fragmentKey}>
      <tr>
        <td>{topic.heading}</td>
        <td>
          <span className="global-tooltip-trigger" title={typeTooltip}>
            {typeName}
          </span>
        </td>
        <td>{topic.title}</td>
      </tr>

      {documents.length > 0 ? (
        <tr>
          <td />
          <td colSpan={2} className="border-top-0">
            <ul className="documents">
              {documents.map((document, j) => {
                const key = `topic-${index}-document-${j}`;
                return (
                  <li key={key}>
                    <span className="file-icon-link global-tooltip-trigger" title={document.url}>
                      <i className={`file-icon ${document.iconClass}`} />
                      {document.name}
                    </span>
                  </li>
                );
              })}
            </ul>
          </td>
        </tr>
      ) : null}
    </React.Fragment>
  );
};
